const SUBSCRIBE = '/Methods/CreateReportSubscription'
const SET_FILTERS = '/Methods/AsyncGetReportData'
const GET_DATA = '/Methods/PublishReportData'
const DELETE_DATA = '/Methods/DeleteReportSubscription'
const GET_DATASOURCE = '/Methods/GetArchiveItems'

/**
 * ChartColumnWorker
 * */
export class ChartColumnWorker {

    constructor(id, type) {
        this.sessionId = +sessionStorage.sessionId
        this.location = window._globalParams.location
        this.instance = this.createAxiosInstance()
    }

    // Запрос {
    //   "sessionId": 106406649
    // }
    // Ответ {
    //   "subscriptionId": 1,
    //   "serverTime": 1682503796775,
    //   "code": 0
    // }
    async CreateReportSubscription(startTime, endTime, IntervalUnit, columns = [], resampleInterval = 1, FormingMethod = 1) {
        try {
            columns = this.generateFilterColumns(columns)
            const data = {
                // subscriptionId: this.subscriptionId,
                sessionId: this.sessionId,
                parameters: {
                    startTime,
                    endTime,
                    FormingMethod, //- OnChange = 0, Periodic = 1, Total = 2
                    resampleInterval, // Для FormingMethod Periodic. Число единиц измерения интервала.
                    IntervalUnit, // Единица измерения интервала. Raw = -1, Second = 0, Minute = 1, Hour = 2, Day = 3, Month = 4
                    Layer: 0, //  Обычно 0. Номер слоя (0, 1, 2). Может быть -1 тогда будет выведен из величины resampleInterval.
                },
                columns,
            }

            const response = await this.instance.post(SUBSCRIBE, data)
            this.subscriptionId = response.data.subscriptionId
        } catch (e) {
            console.log('ERROR IN CreateReportSubscription = ', e)
        }
    }

    // "Ref": "57161", - idpath item-а по значениям которого требуется выборка.
    // "Extrapolate": false, - Экстраполировать для времени больше текущего.
    // "Main": true, - Признак ведущей колонки.
    // "Attribute": 0, - Обычно 0. Отображать значение, время или признак качества полученной точки. Value = 0, Time = 1, Quality = 2 "Type": "test", - Тип колонки который просто возвращается в ответе. "ProcessingParameter": 0, - Параметр обработки. Только для интегральных обработок. (На него будет разделён результат) "Aggregation": - Не совсем опционально "Type": 1, - Тип обработки. LastValue = 0, FirstValue = 1, Integral = 2, Average = 3, IntegralAverage = 4, Max = 5, Min = 6, Interpolation = 7, ExactValue = 8, CountSwitchingOn = 9, Count = 10, Sum = 11, Delta = 12, LastBoundValue = 13, Sampling = 14, FirstBoundValue = 15 "Subtype": 1 - Подтип интегральной обработки. LeftRectangle = 0, Tropecia = 1 "Quality": 0 - Обычно 0x000fbcf4. Битовая маска сложных настроек фильтрации по признаку качества "UsePreviousIntervalValue": 1 - Настройка использования значения с предыдущего интервала только для First/Last[Bound]Value. Default, Yes, No
    // Ответ если успешно
    // {
    //   "subscriptionId": 1,
    //   "requestId": 1,
    //   "serverTime": 1682503946407,
    //   "code": 0
    // }
    // Ответ если передан ошибочный subscriptionId
    // {
    //   "serverTime": 1682502102105,
    //   "hex": "0x80280000",
    //   "codeDescription": "Передан недействительный код подписки",
    //   "code": 2150105088
    // }
    // Ответ если ошибка в других параметрах запроса (Например в endTime)
    // {
    //   "serverTime": 1682502941628,
    //   "hex": "0x80B60000",
    //   "codeDescription": "A value had an invalid syntax.",
    //   "code": 2159411200
    // }
    // async AsyncGetReportData(startTime, endTime, IntervalUnit, columns = [], resampleInterval = 1, FormingMethod = 1) {
    //     try {
    //         columns = this.generateFilterColumns(columns)
    //         const data = {
    //             subscriptionId: this.subscriptionId,
    //             sessionId: this.sessionId,
    //             parameters: {
    //                 startTime,
    //                 endTime,
    //                 FormingMethod, //- OnChange = 0, Periodic = 1, Total = 2
    //                 resampleInterval, // Для FormingMethod Periodic. Число единиц измерения интервала.
    //                 IntervalUnit, // Единица измерения интервала. Raw = -1, Second = 0, Minute = 1, Hour = 2, Day = 3, Month = 4
    //                 Layer: 0, //  Обычно 0. Номер слоя (0, 1, 2). Может быть -1 тогда будет выведен из величины resampleInterval.
    //             },
    //             columns,
    //         }
    //         const response = await this.instance.post(SET_FILTERS, data)
    //         this.requestId = response.data.requestId
    //     } catch (e) {
    //         console.log('ERROR IN AsyncGetReportData = ', e)
    //     }
    // }

    generateFilterColumns(parameters) {
        const result = []
        parameters.forEach((param => {
            const Ref = param.itemId && param.path ? `${param.itemId}.${param.path}` : param.path ? param.path : param.itemId.toString()
            result.push({
                name: param.index.toString(),
                parameters: {
                    Ref,
                    Extrapolate: false,
                    Main: true,
                    Attribute: 0,
                    Aggregation: {
                        Type: param.datatype,
                        UsePreviousIntervalValue: 1,
                    }
                }
            })
        }))
        return result
    }

    // Запрос {
    //   "sessionId": 2146243269,
    //   "subscriptionId" : 1,
    //   "requestId": 1
    // }
    // Ответ параметры запроса верны и результат готов
    // {
    //   "subscriptionId": 1,
    //   "requestId": 1,
    //   "columns": [
    //     {
    //       "name": "time",
    //       "type": "System.DateTime"
    //     },
    //     {
    //       "name": "ColumnName1",
    //       "type": "test"
    //     }
    //   ],
    //   "rows": [ - Массив массивов значений колонок, где первое значение - время
    //     [
    //       1681285274000,
    //       0
    //     ],
    //     [
    //       1681285334000,
    //       3
    //     ],
    //     [
    //       1681285394000,
    //       null
    //     ]
    //   ],
    //   "serverTime": 1681302229182,
    //   "code": 0
    // }
    // Ответ если запрошен не тот requestId
    // {
    //   "subscriptionId": 1,
    //   "requestId": 2,
    //   "serverTime": 1682502740627,
    //   "hex": "0x802A0000",
    //   "codeDescription": "The header for the request is missing or invalid.",
    //   "code": 2150236160
    // }
    async PublishReportData() {
        try {
            const data = {
                subscriptionId: this.subscriptionId,
                sessionId: this.sessionId,
                // requestId: this.requestId,
            }
            const response = await this.instance.post(GET_DATA, data)
            if (response.data.code === 2150760448) setTimeout(() => this.PublishReportData(), 70)
            else if (response.data?.rows && response.data?.columns) this.setHistoryData(response.data.rows, response.data.columns)
        } catch (e) {
            console.log('ERROR IN PublishReportData = ', e)
        }
    }

    // Запрос {
    // "sessionId": 106406649,
    // "subscriptionId" : 1
    // }
    // Ответ если успешно {
    //     "sessionId": 106406649,
    //     "subscriptionId" : 1
    // }
    // Ответ если передан ошибочный subscriptionId {
    //     "serverTime": 1682502102105,
    //     "hex": "0x80280000",
    //     "codeDescription": "Передан недействительный код подписки",
    //     "code": 2150105088
    // }
    async DeleteReportSubscription() {
        try {
            const response = await this.instance.post(DELETE_DATA, { sessionId: this.sessionId, subscriptionId: this.subscriptionId })
            console.log('DeleteReportSubscription = ', response)
        } catch (e) {
            console.log('ERROR IN DeleteReportSubscription = ', e)
        }
    }

    async GetArchiveItems(items) {
        items = items.map(item => ({ path: item.path || "", taskId: 0, itemId: item.itemId || 0 }))
        const response = await this.instance.post(GET_DATASOURCE, { sessionId: this.sessionId, items })
        if (!response.data.items.length) return
        return response
    }

    createAxiosInstance() {
        return axios.create({
            baseURL: `//${this.location.hostname}:${this.location.port}${window._globalParams.RequestServerPrefix}`,
            timeout: 10000,
            headers: { 'X-Custom-Header': 'foobar' }
        });
    }
}